/**
 * YODEYMA_MARKET_TAX — client-side VAT display (product-price-list, cart-line-price, cart-total).
 * Must match Liquid: snippets/yodeyma-market-tax-cents.liquid (c + round(c * p / 100)).
 * Removal: see checklist in snippets/yodeyma-market-tax-cents.liquid; grep YODEYMA_MARKET_TAX.
 */
(function () {
  'use strict';

  function themeSettings() {
    return (window.themeVariables && window.themeVariables.settings) || {};
  }

  function applyMarketTaxCents(cents, variantTaxable) {
    var cfg = themeSettings();
    var c = Math.round(Number(cents)) || 0;
    if (!cfg.displayMarketTaxEnabled || cfg.displayMarketTaxExempt) return c;
    if (variantTaxable === false) return c;
    var p = Number(cfg.displayMarketTaxPercent) || 0;
    if (p <= 0) return c;
    return c + Math.round((c * p) / 100);
  }

  function augmentProductPrice(pp, taxable) {
    if (!pp || pp.price == null) return null;
    var out = Object.assign({}, pp);
    out.price = applyMarketTaxCents(out.price, taxable);
    if (out.compare_at_price != null && out.compare_at_price > 0) {
      out.compare_at_price = applyMarketTaxCents(out.compare_at_price, taxable);
    }
    if (out.unit_price != null && out.unit_price_measurement) {
      out.unit_price = applyMarketTaxCents(out.unit_price, taxable);
    }
    return out;
  }

  function patchProductPriceList() {
    var C = customElements.get('product-price-list');
    if (!C || !C.prototype || typeof C.prototype.render !== 'function') return;
    var proto = C.prototype;
    if (proto.render.__yodeymaMarketTax) return;
    var orig = proto.render;
    proto.render = function yodeymaMarketTaxProductPriceListRender() {
      var cfg = themeSettings();
      if (!cfg.displayMarketTaxEnabled || cfg.displayMarketTaxExempt) {
        return orig.call(this);
      }
      if (!this.productPrice || !this.productPrice.price) {
        return orig.call(this);
      }
      var taxable = !(this.variant && this.variant.taxable === false);
      var aug = augmentProductPrice(this.productPrice, taxable);
      if (!aug) return orig.call(this);
      var prev = this.productPrice;
      this.productPrice = aug;
      try {
        return orig.call(this);
      } finally {
        this.productPrice = prev;
      }
    };
    proto.render.__yodeymaMarketTax = true;
  }

  function cloneCartItemWithMarketTax(item, taxable) {
    var clone = Object.assign({}, item);
    if (item.variant) clone.variant = Object.assign({}, item.variant);
    var keys = [
      'price',
      'discounted_price',
      'compare_at_price',
      'final_line_price',
      'original_line_price',
      'line_compare_at_price',
    ];
    keys.forEach(function (k) {
      var v = clone[k];
      if (typeof v === 'number') {
        clone[k] = applyMarketTaxCents(v, taxable);
      }
    });
    return clone;
  }

  function patchCartLinePrice() {
    var C = customElements.get('cart-line-price');
    if (!C || !C.prototype || typeof C.prototype.render !== 'function') return;
    var proto = C.prototype;
    if (proto.render.__yodeymaMarketTax) return;
    var orig = proto.render;
    proto.render = function yodeymaMarketTaxCartLinePriceRender() {
      var cfg = themeSettings();
      if (!cfg.displayMarketTaxEnabled || cfg.displayMarketTaxExempt || !this.item) {
        return orig.call(this);
      }
      var v = this.item.variant;
      var taxable = !v || v.taxable !== false;
      var clone = cloneCartItemWithMarketTax(this.item, taxable);
      var prev = this.item;
      this.item = clone;
      try {
        return orig.call(this);
      } finally {
        this.item = prev;
      }
    };
    proto.render.__yodeymaMarketTax = true;
  }

  /**
   * Theme cart-total uses M(cart.total_price) only — unlike cart-line-price it does not get the
   * display-VAT layer, so checkout button can show 24,59€ while lines show 29,75€ after logout.
   */
  function patchCartTotal() {
    var C = customElements.get('cart-total');
    if (!C || !C.prototype || typeof C.prototype._onCartUpdated !== 'function') return;
    var proto = C.prototype;
    if (proto._onCartUpdated.__yodeymaMarketTax) return;
    var orig = proto._onCartUpdated;
    proto._onCartUpdated = function yodeymaMarketTaxCartTotalUpdated(detail) {
      var cfg = themeSettings();
      var d = detail;
      if (!cfg.displayMarketTaxEnabled || cfg.displayMarketTaxExempt || !d || d.total_price == null) {
        return orig.call(this, d);
      }
      var displayTotal;
      if (d.items && Array.isArray(d.items) && d.items.length) {
        displayTotal = 0;
        d.items.forEach(function (item) {
          var tax = !(item.variant && item.variant.taxable === false);
          var line = typeof item.final_line_price === 'number' ? item.final_line_price : 0;
          displayTotal += applyMarketTaxCents(line, tax);
        });
      } else {
        displayTotal = applyMarketTaxCents(d.total_price, true);
      }
      return orig.call(this, Object.assign({}, d, { total_price: displayTotal }));
    };
    proto._onCartUpdated.__yodeymaMarketTax = true;

    /* Header mini-cart cart-total often connects before this script; theme does bind(this._onCartUpdated).
       That closes over the pre-patch function — reconnect so the store uses the wrapped handler. */
    document.querySelectorAll('cart-total').forEach(function (el) {
      try {
        if (typeof el.disconnectedCallback === 'function') el.disconnectedCallback();
        if (typeof el.connectedCallback === 'function') el.connectedCallback();
      } catch (e) {}
    });
    /* Do not fetch cart.js here: SSR <cart-total> now matches the patch — immediate fetch caused a visible flash. */
  }

  /**
   * Keep cart-original-total (strikethrough) aligned with market tax.
   * It is updated from cart payloads after AJAX actions, so SSR alone is not enough.
   */
  function patchCartOriginalTotal() {
    var C = customElements.get('cart-original-total');
    if (!C || !C.prototype || typeof C.prototype._onCartUpdated !== 'function') return;
    var proto = C.prototype;
    if (proto._onCartUpdated.__yodeymaMarketTax) return;
    var orig = proto._onCartUpdated;
    proto._onCartUpdated = function yodeymaMarketTaxCartOriginalTotalUpdated(detail) {
      var cfg = themeSettings();
      var d = detail;
      if (!cfg.displayMarketTaxEnabled || cfg.displayMarketTaxExempt || !d) {
        return orig.call(this, d);
      }

      var displayOriginalTotal = 0;
      if (d.items && Array.isArray(d.items) && d.items.length) {
        d.items.forEach(function (item) {
          var qty = Number(item && item.quantity) || 0;
          var lineOriginal = typeof item.original_line_price === 'number' ? item.original_line_price : 0;
          var hasVariant = !!(item && item.variant);
          var compareAt = hasVariant && typeof item.variant.compare_at_price === 'number' ? item.variant.compare_at_price : null;
          var variantPrice = hasVariant && typeof item.variant.price === 'number' ? item.variant.price : null;

          // Match cart-complement-json logic: include compare-at deltas into original total baseline.
          if (compareAt != null && variantPrice != null && compareAt > variantPrice && qty > 0) {
            lineOriginal += (compareAt - variantPrice) * qty;
          }

          var taxable = !(hasVariant && item.variant.taxable === false);
          displayOriginalTotal += applyMarketTaxCents(lineOriginal, taxable);
        });
      } else if (d.original_total_price != null) {
        displayOriginalTotal = applyMarketTaxCents(d.original_total_price, true);
      } else {
        return orig.call(this, d);
      }

      return orig.call(this, Object.assign({}, d, { original_total_price: displayOriginalTotal }));
    };
    proto._onCartUpdated.__yodeymaMarketTax = true;

    document.querySelectorAll('cart-original-total').forEach(function (el) {
      try {
        if (typeof el.disconnectedCallback === 'function') el.disconnectedCallback();
        if (typeof el.connectedCallback === 'function') el.connectedCallback();
      } catch (e) {}
    });
  }

  function refreshCartTotalsFromApi() {
    if (!document.querySelector('cart-total')) return;
    var base = (window.themeVariables.routes && window.themeVariables.routes.cartUrl) || '/cart';
    var url = base.indexOf('.js') === -1 ? base + '.js' : base;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('cart-total').forEach(function (el) {
          if (typeof el._onCartUpdated === 'function') {
            el._onCartUpdated(cart);
          }
        });
      })
      .catch(function () {});
  }

  function refreshPriceDisplays() {
    document.querySelectorAll('cart-line-price').forEach(function (el) {
      if (typeof el.render === 'function') el.render();
    });
    document.querySelectorAll('product-price-list').forEach(function (el) {
      if (typeof el.render === 'function') el.render();
    });
    refreshCartTotalsFromApi();
  }

  var syncTimer = null;
  function syncMarketTaxCustomerState() {
    if (!window.themeVariables || !window.themeVariables.settings) return;
    var cfg = themeSettings();
    if (!cfg.displayMarketTaxEnabled) return;

    var u = new URL(window.location.href);
    u.searchParams.set('sections', 'yodeyma-market-tax-state');

    fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var html = data && data['yodeyma-market-tax-state'];
        if (!html || typeof html !== 'string') return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.getElementById('yodeyma-market-tax-state');
        if (!node || !node.textContent) return;
        var parsed = JSON.parse(node.textContent.trim());
        var s = window.themeVariables.settings;
        var prevEnabled = s.displayMarketTaxEnabled;
        var prevExempt = s.displayMarketTaxExempt;
        var prevPercent = Number(s.displayMarketTaxPercent || 0);
        if (typeof parsed.displayMarketTaxEnabled === 'boolean') {
          s.displayMarketTaxEnabled = parsed.displayMarketTaxEnabled;
        }
        if (typeof parsed.displayMarketTaxExempt === 'boolean') {
          s.displayMarketTaxExempt = parsed.displayMarketTaxExempt;
        }
        if (parsed.displayMarketTaxPercent != null) {
          s.displayMarketTaxPercent = Number(parsed.displayMarketTaxPercent) || 0;
        }
        var changed =
          (typeof parsed.displayMarketTaxEnabled === 'boolean' &&
            parsed.displayMarketTaxEnabled !== prevEnabled) ||
          (typeof parsed.displayMarketTaxExempt === 'boolean' && parsed.displayMarketTaxExempt !== prevExempt) ||
          (parsed.displayMarketTaxPercent != null && Number(parsed.displayMarketTaxPercent || 0) !== prevPercent);
        if (changed) refreshPriceDisplays();
      })
      .catch(function () {});
  }

  function scheduleSyncMarketTaxCustomerState() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncMarketTaxCustomerState, 200);
  }

  /**
   * After login/logout, themeVariables.*Exempt* stays stale until we refetch Liquid.
   * Do not hook GET /cart.js: the theme fetches it on almost every page load and would re-run
   * section sync + refreshPriceDisplays (visible price flash on home).
   * Use visibilitychange / cart mutations / logout / customer_authentication, or
   * document.dispatchEvent(new CustomEvent('yodeyma:market-tax-sync-customer')).
   */
  function storefrontFetchShouldSyncCustomerTax(url) {
    if (!url || typeof url !== 'string') return false;
    if (/\/cart\/(add|change|update|clear)\.js(\?|#|$)/.test(url)) return true;
    if (/\/account\/logout(\?|#|$)/i.test(url)) return true;
    if (/\/customer_authentication\//i.test(url)) return true;
    return false;
  }

  function installCustomerStateSyncHooks() {
    if (!window.themeVariables || !themeSettings().displayMarketTaxEnabled) return;
    if (installCustomerStateSyncHooks.__done) return;
    installCustomerStateSyncHooks.__done = true;

    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var req = args[0];
      var url = typeof req === 'string' ? req : req && req.url ? req.url : '';
      return origFetch.apply(this, args).then(function (res) {
        if (res.ok && storefrontFetchShouldSyncCustomerTax(url)) {
          scheduleSyncMarketTaxCustomerState();
        }
        return res;
      });
    };

    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) scheduleSyncMarketTaxCustomerState();
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) scheduleSyncMarketTaxCustomerState();
    });

    document.addEventListener(
      'yodeyma:market-tax-sync-customer',
      function () {
        scheduleSyncMarketTaxCustomerState();
      },
      false
    );
  }

  function init() {
    if (!window.themeVariables) return;
    var cfg = themeSettings();
    if (!cfg.displayMarketTaxEnabled) return;

    installCustomerStateSyncHooks();

    Promise.all([
      customElements.whenDefined('product-price-list').then(patchProductPriceList),
      customElements.whenDefined('cart-line-price').then(patchCartLinePrice),
      customElements.whenDefined('cart-total').then(patchCartTotal),
      customElements.whenDefined('cart-original-total').then(patchCartOriginalTotal),
    ])
      .then(function () {
        document.querySelectorAll('cart-line-price').forEach(function (el) {
          if (typeof el.render === 'function') el.render();
        });
        document.querySelectorAll('product-price-list').forEach(function (el) {
          if (typeof el.render === 'function') el.render();
        });
      })
      .catch(function () {});
  }

  /* Defer scripts run after full parse (readyState is usually interactive): run init immediately so
     prototypes are patched before product JSON microtasks paint pre-tax prices. */
  init();

  window.yodeymaMarketTaxApplyCents = applyMarketTaxCents;
  window.yodeymaMarketTaxSyncCustomerState = syncMarketTaxCustomerState;
})();
